// extracted by mini-css-extract-plugin
module.exports = {"value":"i_IM","container":"i_IN","label":"i_IO","field":"i_IP","icon":"i_IQ"};